export default "__VITE_ASSET__dcd99755__"